import DOMOrderSync from '@wielink-application/shared/js/base/menu/DOMOrderSync';
export default DOMOrderSync;